import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import style from './markdown.module.css';

type SparkMarkdownProps = {
  children: string;
};
function SparkMarkdown({ children = '' }: SparkMarkdownProps) {
  return (
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      rehypePlugins={[rehypeRaw]}
      className={style.markdown}
      components={{
        p: ({ children }) => {
          if (typeof children === 'string') {
            const parts = children.split('\n').map((part, i) => (
              <React.Fragment key={i}>
                {i > 0 && <br />}
                {part}
              </React.Fragment>
            ));
            return <p>{parts}</p>;
          }
          return <p>{children}</p>;
        }
      }}
    >
      {children}
    </ReactMarkdown>
  );
}

export default SparkMarkdown;
